module.exports = __webpack_public_path__ + "static/media/active.a7bc6cc8.svg";